<!-- A month picked from a menu under whatever it sits in (activator="parent"):
     the year stepped with arrows, then the month from Vuetify's month grid, in
     Estonian. Instead of <input type="month">, whose picker the browser draws
     in its own language. The value is 'YYYY-MM', or '' for none. -->
<template>
  <v-menu v-model="open" activator="parent" :close-on-content-click="false" location="bottom end" min-width="290">
    <v-card class="month-menu">
      <div class="d-flex align-center pa-2">
        <v-btn icon="mdi-chevron-left" variant="text" size="small" aria-label="Eelmine aasta" @click="year--" />
        <v-spacer />
        <span class="text-subtitle-1 font-weight-medium">{{ year }}</span>
        <v-spacer />
        <v-btn icon="mdi-chevron-right" variant="text" size="small" aria-label="Järgmine aasta" @click="year++" />
      </div>
      <!-- Not v-date-picker-months: opened with no month it picks the current
           one by itself and reports that as the reader's choice. -->
      <div class="month-menu__grid">
        <v-btn
          v-for="(name, index) in MONTHS"
          :key="name"
          :variant="index === month ? 'flat' : 'text'"
          :color="index === month ? 'primary' : undefined"
          rounded="xl"
          size="small"
          @click="pick(index)"
        >{{ name }}</v-btn>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import dayjs from 'dayjs'

const MONTHS = ['jaan', 'veebr', 'märts', 'apr', 'mai', 'juuni', 'juuli', 'aug', 'sept', 'okt', 'nov', 'dets']

export default {
  props: {
    modelValue: { type: String, default: '' }
  },
  emits: ['update:modelValue'],
  data () {
    return { open: false, year: dayjs().year(), MONTHS }
  },
  computed: {
    // The grid marks the picked month only while it shows that year.
    month () {
      if (!this.modelValue) return undefined
      const picked = dayjs(this.modelValue + '-01')
      return picked.year() === this.year ? picked.month() : undefined
    }
  },
  watch: {
    open (open) {
      if (open) this.year = this.modelValue ? dayjs(this.modelValue + '-01').year() : dayjs().year()
    }
  },
  methods: {
    pick (month) {
      this.open = false
      this.$emit('update:modelValue', dayjs().year(this.year).month(month).format('YYYY-MM'))
    }
  }
}
</script>

<style scoped>
.month-menu__grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 6px; padding: 4px 12px 14px; }
</style>
